import React from "react";
import { NavLink, useMatch } from "react-router-dom";

/**
 * One navigation link (v1.3 ticket 11, RCMC-04 / -09). Named by its label, which stays in the accessibility tree when
 * the collapsed sidebar hides it (SideListView.css); the icon is decoration, hidden from screen readers.
 * Highlighted for its whole section, as in v1.2, but aria-current="page" only on the page itself: on a page below it
 * (a Service Request's page under "Service Requests") the link is the current section ("true"), not the current page.
 * @param {string} to  the page's path
 * @param {React.ComponentType} icon  a react-icons component
 * @param {string} label  the visible label, and the link's name
 */
const NavItem = ({ to, icon: Icon, label }) => {
  const onThisPage = Boolean(useMatch({ path: to, end: true }));
  return (
    <li>
      <NavLink to={to} className={({ isActive }) => (isActive ? "active" : "")} aria-current={onThisPage ? "page" : "true"}>
        <Icon aria-hidden="true" />
        <strong>{label}</strong>
      </NavLink>
    </li>
  );
};

export default NavItem;
